module.exports = __webpack_public_path__ + "static/img/Collegeshare.a37a5c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Collegeshare.png
// module id = 502
// module chunks = 1